/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccountCategoryEnum } from './accountCategoryEnum';
import { AccountCountSummary } from './accountCountSummary';


export interface AccountCategorySummary { 
    category: AccountCategoryEnum;
    count_summary: AccountCountSummary;
}
export namespace AccountCategorySummary {
}


